module.exports = __webpack_public_path__ + "static/media/bg-title.e4d71429.svg";